import { inject, Service } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RuntimeConfigService } from '../services/config/runtime-config.service';
import { environment } from '../../environments/environment';

@Service()
export class AdminEnabledGuard implements CanActivate {
  private readonly config = inject(RuntimeConfigService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (environment.adminEnabled) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
